import { NgDocCategory } from '@ng-doc/core';

const AngularMaterielCategory: NgDocCategory = {
  title: 'Angular-material',
  order: 5,
};

export default AngularMaterielCategory;
